export const ENERGY_USAGE_PAGE_CONST = {
    localStorage: {
        sidebarCollapsedKey: 'EnergyUsageSidebarCollapse',
        siteFiltersCollapsedKey: 'EnergyUsageSidebarSiteFiltersCollapse',
    },

    filtersWidth: 250,
    sitesPanelWidth: 300,
    filtersCollapsedWidth: 40,

    expandedWidth: 250 + 300, // NOTE: sitesPanelWidth + filtersWidth
};
